<template>
    <div class="swiperDate">
        <div class="carousel__arrow" @click="pageClick(-1)">
            <i class="iconfont icon-youla"></i>
        </div>
        <el-carousel height="90px" ref="carousel" @change="change" 
            :autoplay="false" indicator-position="none" trigger="click" :initial-index="dateIndex">
            <el-carousel-item>
                <div class="date-list" data-index="0">
                    <div class="date-item" :class="{selected:currentDate && item.fulldate==currentDate.fulldate}"
                        v-for="item in preDays" :key="item" @click="choiceDate(item)">
                        {{item.lunar.ncWeek}}
                        <div class="date-text">
                            {{ item.lunar.cDay }}
                            <span class="unit" v-if="item.day==0">今</span>
                            <span class="unit" v-else-if="item.day==1">明</span>
                            <span class="unit" v-else-if="item.day==2">后</span>
                        </div>
                        <div>{{item.lunar.lunarDay}}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="date-list" data-index="1">
                    <div class="date-item" :class="{selected:currentDate && item.fulldate==currentDate.fulldate}"
                        v-for="item in days" :key="item" @click="choiceDate(item)">
                        {{item.lunar.ncWeek}}
                        <div class="date-text">
                            {{ item.lunar.cDay }}
                            <span class="unit" v-if="item.day==0">今</span>
                            <span class="unit" v-else-if="item.day==1">明</span>
                            <span class="unit" v-else-if="item.day==2">后</span>
                        </div>
                        <div>{{item.lunar.lunarDay}}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="date-list" data-index="2">
                    <div class="date-item" :class="{selected:currentDate && item.fulldate==currentDate.fulldate}"
                        v-for="item in nextDays" :key="item" @click="choiceDate(item)">
                        {{item.lunar.ncWeek}}
                        <div class="date-text">
                            {{ item.lunar.cDay }}
                            <span class="unit" v-if="item.day==0">今</span>
                            <span class="unit" v-else-if="item.day==1">明</span>
                            <span class="unit" v-else-if="item.day==2">后</span>
                        </div>
                        <div>{{item.lunar.lunarDay}}</div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="carousel__arrow" @click="pageClick(1)">
            <i class="iconfont icon-zuola"></i>
        </div>
    </div>
</template>

<script>
import {getLunar} from 'chinese-lunar-calendar'
const heavenlyStemStr = '甲乙丙丁戊己庚辛壬癸';
 //js计算天数差的函数，通用  
function dateDiff(sDate1,  sDate2){
    //把相差的毫秒数转换为天数
    return parseInt((new Date((new Date(sDate1)).Format("yyyy-MM-dd"))  - new Date((new Date(sDate2)).Format("yyyy-MM-dd")) ) /  1000  /  60  /  60  /24)      
}
export default {
    name:"swiperDate",
    props:{
        //设置当前选中的日期
        date:{
            type:[String,Date],
            default:null
        }
    },
    watch:{
        date(){
            if(!this.currentDate || this.date!=this.currentDate.fulldate){
                this.setDate(this.date);
            }
        }
    },
    data(){
        return {
            //是否无法向前了
			isDateEnd:true,
            nubmerStr:"一二三四五六七八九十",
            week:"日一二三四五六",
            pageSize:6,
            //当前页码
            pageIndex:0,
            //时间滑动
			dateIndex:0,
            //当前页 天数
            days: [],
            //上页 天数
            preDays: [],
            //下页 天数
            nextDays: [],
            //当前选中日期
            currentDate:null,
            //当前年月
			swiperCurrentDate:new Date().Format("yyyy-MM-dd"),
        }
    },
    mounted(){
        this.newDay=new Date().Format("yyyy-MM-dd");
        this.setDate(this.date);
    },
    methods:{
        //点击日期
        choiceDate(item){
            this.currentDate=item;
            this.$emit("change",item);
        },
        setActiveItem(index){
            this.$refs.carousel.setActiveItem(index);
        },
        setDate(currentDate){
            this.initSwiperDate(currentDate);
            const date=new Date(currentDate);
            let lunar=this.getLunar(date.getFullYear(), date.getMonth()+1, date.getDate());

            this.currentDate={
                fulldate:date.Format("yyyy-MM-dd"),
                lunar:lunar
            };
        },
        change(current, prev){
            // 非用户滑动不执行
            if (current==this.dateIndex) return;
            let direction;//方向
            if(this.isDateEnd){
                if(current>this.dateIndex){//下一页
                    direction="next";
                }else{
                    direction="pre";//上一页
                }
            }else{
                if (current - this.dateIndex == 1 || current - this.dateIndex == -2) {
                    direction="next";
                }else{
                    direction="pre";//上一页
                }
            }
            this.dateIndex=current;
            this.updateWeeks(direction);
        },
        updateWeeks(direction) {
            // 防止一次渲染过多数据，造成对nvue的卡顿
            this.$nextTick(() => {
                
                if(this.isDateEnd){//没有上一页了
                    if(direction=="next" && this.dateIndex==2){
                        this.swiperCurrentDate=this.nextDays[0].fulldate;
                    }else{
                        return;
                    }
                }else{
                    let date=new Date(this.swiperCurrentDate);
                    if(direction=="next"){
                        date.setDate(date.getDate()+this.pageSize);
                    }else{
                        date.setDate(date.getDate()-this.pageSize);
                    }
                    this.swiperCurrentDate=date.Format("yyyy-MM-dd");
                }
                
                let nextDays = this.getDays(this.swiperCurrentDate,this.pageSize);
                let preDays = this.getDays(this.swiperCurrentDate,-this.pageSize);
        
                if (this.dateIndex == 0) {
                    this.days = nextDays;
                    this.nextDays = preDays;
                } else if (this.dateIndex == 1) {
                    this.nextDays = nextDays;
                    this.preDays = preDays;
                } else {
                    this.preDays = nextDays;
                    this.days = preDays;
                }
                const day=dateDiff(preDays[0].fulldate,this.newDay);
                if(day>0){
                    this.isDateEnd=false;
                }else{
                    this.isDateEnd=true;
                }
                
            })
        },
        pageClick(index){
            if(index<0){//上一页
                if(this.isDateEnd && this.dateIndex==0){
                    return;
                }
                this.$refs.carousel.prev();
                this.pageIndex--;
            }else if(index>0){//下一页
                this.$refs.carousel.next();
                this.pageIndex++;
            }
        },
        //初始化 日期滚动
        initSwiperDate(date){
            //相差天数
            let day=dateDiff(date,this.newDay);
            if(day<0){
                date=this.newDay;//默认 是今天
                day=0;
            }
            let index=parseInt(day/this.pageSize);
            const d=day-index*this.pageSize;
            date=new Date(date);
            if(d>0){
                date.setDate(date.getDate()-d);
            }
            const currentDate=date.Format("yyyy-MM-dd")
            if(index==0){//没有上一页
                this.isDateEnd=true;
                //上页 天数
                this.preDays= this.getDays(currentDate,0);
                //当前页 天数
                this.days= this.getDays(currentDate,this.pageSize);
                //下页 天数
                this.nextDays= this.getDays(currentDate,this.pageSize*2);
                this.dateIndex=0;
            }else{
                this.isDateEnd=false;
                this.dateIndex=index%3;//计算当前位置
                if(this.dateIndex==0){
                    this.preDays=this.getDays(currentDate);
                    this.days=this.getDays(currentDate,this.pageSize);
                    this.nextDays=this.getDays(currentDate,-this.pageSize);
                }else if(this.dateIndex==1){
                    this.preDays=this.getDays(currentDate,-this.pageSize);
                    this.days=this.getDays(currentDate);
                    this.nextDays=this.getDays(currentDate,this.pageSize);
                }else if(this.dateIndex==2){
                    this.preDays=this.getDays(currentDate,this.pageSize);
                    this.days=this.getDays(currentDate,-this.pageSize);
                    this.nextDays=this.getDays(currentDate);
                }
            }
            this.swiperCurrentDate=currentDate;//当前页 开始时间
            this.$refs.carousel.setActiveItem(this.dateIndex);

            
        },
        getDays(currentDate,day){
            const date=new Date(currentDate);
            if(day>0 || day<0){
                date.setDate(date.getDate()+day);
            }
            
            let list=[];
            for(let i=0;i<this.pageSize;i++){
                let lunar=this.getLunar(date.getFullYear(), date.getMonth()+1, date.getDate());
                list.push({
                    fulldate:date.Format("yyyy-MM-dd"),
                    day:dateDiff(date,this.newDay),//与今天相差天数
                    lunar:lunar
                });
                date.setDate(date.getDate()+1);
            }
            return list;
        },
        getLunar(year,month,day){
            let lunar=getLunar(year,month,day);
            let cDate=new Date(year,month-1,day);
            lunar.ncWeek="星期"+this.week[cDate.getDay()];
            lunar.cDay=cDate.getDate();
            let date=lunar.lunarDate;
            if (date <= 10) {
                lunar.lunarDay=`初${this.nubmerStr[date - 1]}`;
            } else if (date < 20) {
                lunar.lunarDay=`十${this.nubmerStr[date - 11]}`;
            } else if (date == 20) {
                lunar.lunarDay=`廿十`;
            } else if (date > 20) {
                lunar.lunarDay=`廿${this.nubmerStr[date - 21]}`;
            } else {
                lunar.lunarDay=`三十`;
            }
 
            if(lunar.lunarYear){
                let heavenlyStem=heavenlyStemStr.indexOf(lunar.lunarYear[0]);
                if((year-(1900-6))%10 != heavenlyStem){
                    lunar.year= year-1;
                }else{
                    lunar.year= year;
                }
            }
            return lunar;
        },
    }
}
</script>

<style lang="scss">
.swiperDate{
    display: flex;
    padding:0 5px;

    .carousel__arrow{
        width: 40px;
        margin: 0 5px;
        text-align: center;
        line-height: 90px;
        cursor: pointer;

        .iconfont{
            font-size: 20px;
            color: #6F7684;
        }
    }

    .el-carousel{
        flex:1;
        overflow: hidden;

        .el-carousel__arrow{
            display: none;
        }
    }

    .date-list{
        display: flex;
        padding: 0 5px;
        gap: 5px;
    }

    .date-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 90px;
        background-color: #fff;
        border-radius: 8px;
        cursor: pointer;
        font-weight: 400;
        font-size: 10px;
        color: #424753;
        
        .date-text {
            margin-top: 5px;
            font-weight: bold;
            font-size: 14px;
            color: #333333;

            .unit{
                font-weight: 400;
                font-size: 10px;
                color: #424753;
            }
        }

        &.selected{
            background-color: #1565D8;
            color: #fff;

            .date-text {
                color: #fff;

                .unit{
                    color: #fff;
                }
            }
        }
    }
}
</style>